import App from '../app';
import {AppSession} from '../model/App';

export default function currentSession(): AppSession {
  return App.useQuery(state => state.session)
}